import { render, staticRenderFns } from "./ClientTag.vue?vue&type=template&id=6689a176&"
import script from "./ClientTag.vue?vue&type=script&lang=js&"
export * from "./ClientTag.vue?vue&type=script&lang=js&"
import style0 from "./ClientTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClientTag.vue"
export default component.exports